export default __webpack_public_path__ + "static/media/detail_big_2_1.dd37093d.png";